import { gql } from "@apollo/client";

export default gql`
  query getMeetingBotStatusQuery($meetingId: Int!) {
    meeting(meetingId: $meetingId) {
      id
      botIsRecording
      botIsWaitingToJoinMeeting
      hasBotInMeeting
    }
  }
`;
